export enum ChartTypeEnum {
  CandleStick,
  HollowCandles,
  Bars,
  Line,
  LineWMarkers,
  Columns,
  Area,
  Histogram,
  // Fills between the line and a reference value (0 by default) rather than
  // down to the chart's bottom axis like Area — the right tool for a
  // drawdown/underwater series, which is always <= 0 and needs the shaded
  // region to sit between the line and zero, not the axis minimum.
  Baseline,
}

export function chartTypeDataType(ct: ChartTypeEnum): string {
  switch (ct) {
    case ChartTypeEnum.CandleStick:
    case ChartTypeEnum.Bars:
    case ChartTypeEnum.HollowCandles:
    case ChartTypeEnum.Area:
    case ChartTypeEnum.Columns:
    case ChartTypeEnum.LineWMarkers:
    case ChartTypeEnum.Line:
    case ChartTypeEnum.Histogram:
    case ChartTypeEnum.Baseline:
      return 'candle_data';
  }
}
